import React from 'react';
import { ContentGenerationRecord } from "../types";
import { GenerationStatus, GenerationStatusEnum } from "../types";
import { getProductImageUrl } from 'src/utils/image';

const clickableStyle = {
  textDecoration: 'none'
};

interface ProductInfoProps {
  data: ContentGenerationRecord;
  variant?: 'default' | 'modal';
}

const ProductInfo: React.FC<ProductInfoProps> = ({ data, variant = 'default' }) => {
  const status = data.status as GenerationStatus;
  const redirectToReview =
    status === GenerationStatusEnum.enum.READY_TO_REVIEW || status === GenerationStatusEnum.enum.REVIEWED;

  const width = variant === 'modal' ? '336px' : '388px';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', width }}>
      <img
        src={getProductImageUrl(data.stacklineSku)}
        alt={data.product?.title || 'Product image'}
        style={{ width: '30px', height: '30px', objectFit: 'cover' }}
      />
      <span
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...(redirectToReview && clickableStyle)
        }}
      >
        {data.product?.title || '-'}
      </span>
    </div>
  );
};

export default ProductInfo;